'use client';

import {createContext, useMemo} from 'react';

import {useLocalSetting, type LocalSetting} from '@/hooks/local-storage';

export const SettingContext = createContext<ReturnType<
  typeof useLocalSetting
> | null>(null);

export default function SettingProvider({
  children,
  initialData
}: {
  children: React.ReactNode;
  initialData?: LocalSetting;
}) {
  const setting = useLocalSetting('setting', false, true, initialData);

  return (
    <SettingContext
      value={useMemo(
        () => setting,
        [setting[0]] // eslint-disable-line react-hooks/exhaustive-deps
      )}>
      {children}
    </SettingContext>
  );
}
